var compVariantInitialized = {};

$("body").on("click", ".color-swatch-list .option-values-option", function () {
  var $swatch = $(this);
  var $wrapper = $swatch.closest(".swatch-list-wrapper");
  var $card = $swatch.closest(".card__information, .comp-card__bottom");
  var colorcode = $swatch.attr("data-color-code");

  $swatch.siblings().removeClass("selected");
  $swatch.addClass("selected");
  $wrapper.find(".selected-color span").css({
    background: colorcode,
    "background-size": "cover",
  });
  $(".color-swatch-list").not($wrapper.find(".color-swatch-list")).hide();
  $wrapper.find(".color-swatch-list").hide();
  updateCompVariant($card);
});
$("body").on("change", ".size-dropdown", function () {
  var productId = $(this).attr("name").replace("size-option-", "");
  compVariantInitialized[productId] = true;
  const $this = $(this);
  $this.find("option").removeClass("selected");
  $this.find("option:selected").addClass("selected");
  var selectedSize = $this.find("option:selected").attr("data-value-size");
  var variantId = $this.find("option:selected").attr("data-variant-id");
  var variantQuantity = 0;
  $this
    .closest(".card__information, .comp-card__bottom")
    .find(".product-variants .variant-item")
    .each(function () {
      if ($(this).attr("data-variant-id") === variantId) {
        variantQuantity = parseInt($(this).attr("data-quantity"));
        return false;
      }
    });
  var $button = $this.closest(".card__information, .comp-card__bottom").find(".Comp_add_btn");
  $button.attr("data-pid", variantId);
  $button.attr("data-variant-id", variantId);
  if (variantQuantity === 0) {
    $button.prop("disabled", true).addClass("disabled").text("Sold out");
  } else {
    $button.prop("disabled", false).removeClass("disabled").text("Add to cart");
  }
  /*updateCompVariant($this.closest(".card__information, .comp-card__bottom"));*/
});
function updateCompVariant($card) {
  var selectedColor = $card
    .find(".color-swatch-list .option-values-option.selected")
    .attr("data-value");
  var selectedSize = $card
    .find(".size-dropdown option:selected")
    .attr("data-value-size");
  var variantFound = false;
  $card.find(".product-variants .variant-item").each(function () {
    var option1 = ($(this).attr("data-option1") || "")
      .toLowerCase()
      .replace(/\s+/g, "-");
    var option2 = ($(this).attr("data-option2") || "")
      .toLowerCase()
      .replace(/\s+/g, "-");
    if ((option1 === selectedColor && option2 === selectedSize) ||
      (option1 === selectedSize && option2 === selectedColor) ||
      (!selectedSize && (option1 === selectedColor || option2 === selectedColor))) {
      var variantId = $(this).attr("data-variant-id");
      var availableQuantity = parseInt($(this).attr("data-quantity"));
      var isAvailable = availableQuantity > 0;
      var $button = $card.find(".Comp_add_btn");
      $button.attr("data-pid", variantId);
      $button.attr("data-variant-id", variantId);
      if (isAvailable) {
        $button
          .prop("disabled", false)
          .removeClass("disabled")
          .text("Add to cart");
          console.log($button);
      } else {
        $button.prop("disabled", true).addClass("disabled").text("Sold out");
      }
      variantFound = true;
      return false;
    }
  });
  if (!variantFound) {
    var $button = $card.find(".Comp_add_btn");
    $button.prop("disabled", true).text("Please select a variant");
  }
  
  setTimeout(function() {
  $('product-form button.product-form__submit').prop('disabled', false);
}, 800);

console.log("asdf");
}
$("body").on("click", ".selected-color", function () {
  var $trigger = $(this);
  var $wrapper = $trigger.closest(".swatch-list-wrapper");
  var $list = $wrapper.find(".color-swatch-list").first();

  $(".color-swatch-list").not($list).hide();
  $list.toggle();
});
$("body").on("click", ".Comp_add_to_cart button", function () {
  if ($(this).is("[data-cart-upsell-add]")) {
    return;
  }
  var cpid = parseInt($(this).attr("data-pid"));
  if (!cpid) {
    alert("Please select a valid variant.");
    return;
  }
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { id: cpid, quantity: 1 },
    dataType: "json",
    success: function (response) {
      console.log("Item added to cart:", response);
      refreshCartDrawer();
      updateCartBubbleCount();
    },
    error: function (xhr, status, error) {
      console.error("Error adding to cart:", error);
    },
  });
});
function refreshCartDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  const cartDrawerItems = document.querySelector("cart-drawer-items");
  const cartDrawerCheckout = document.querySelector("#CartDrawer-Checkout");
  if (cartDrawer) {
    cartDrawer.classList.remove("is-empty");
    const emptyDrawerElement = cartDrawer.querySelector(".drawer__inner-empty");
    if (emptyDrawerElement) emptyDrawerElement.remove();
    const cartContentsForm = document.querySelector(".cart__contents");
    if (cartContentsForm) cartContentsForm.style.display = "block";
    if (cartDrawerCheckout) cartDrawerCheckout.removeAttribute("disabled");
    if (!cartDrawerItems) {
      const newCartItems = document.createElement("cart-drawer-items");
      const drawerHeader = document.querySelector(".drawer__header");
      if (drawerHeader) {
        drawerHeader.insertAdjacentElement("afterend", newCartItems);
      }
    }
    const updatedCartItems = document.querySelector("cart-drawer-items");
    if (
      updatedCartItems &&
      typeof updatedCartItems.onCartUpdate === "function"
    ) {
      updatedCartItems.onCartUpdate();
    }
    if (typeof cartDrawer.open === "function") {
      cartDrawer.open();
    }
  }
}
function updateCartBubbleCount() {
  $.getJSON("/cart.js", function (cart) {
    const itemCount = cart.item_count;
    const bubble = document.querySelector(".cart-count-bubble");
    if (bubble) {
      bubble.innerText = itemCount;
      bubble.style.display = itemCount > 0 ? "inline-block" : "none";
    }
  });
}
document.querySelectorAll(".mega-menu").forEach((item) => {
  let openedByHover = false;
  item.addEventListener("mouseenter", () => {
    if (!item.hasAttribute("open")) {
      item.setAttribute("open", "");
      openedByHover = true;
    }
  });
  item.addEventListener("mouseleave", () => {
    if (openedByHover) {
      setTimeout(function () {
        item.removeAttribute("open");
        openedByHover = false;
      }, 1000);
    }
  });
});
